module.exports = {"id":"218868","name":"Alejandro Silva","rating":"75","photo":"./data/images/photos/0/218868.png","club":{"name":"Impact Montréal","logo":"./data/images/clubs/ImpactMontreal.png"},"positions":["AD","DD","MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlejandroSilva0.json
// module id = 184
// module chunks = 0